import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "solution-footer"
};
const _hoisted_2 = {
  class: "solution-footer-content"
};
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h2 class=\"footer-title\">链接出海易 掌握主动权</h2><div class=\"footer-desc\"><p class=\"footer-desc-line\">秉承百度“用科技让复杂的世界更简单”的使命，</p><p class=\"footer-desc-line\">出海易围绕出海企业的日常需求和业务场景，致力成为最懂企业需求的出海业务管家，</p><p class=\"footer-desc-line\">助力中企品牌出海，在贸易新时代掌握主动权。</p></div>", 2);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_t_solution_button = _resolveComponent("t-solution-button");
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_t_solution_button, {
    title: "预约一对一咨询",
    class: "btn-contact-us"
  })])]);
}